import { KnitivEditor } from '@knitiv/text-editor';
import APIV5 from '~/models/api';
import { UserModel } from '~/scripts/services/model/user';

export default class PopInfoController {
	/* @ngInject */
	/**
	 * @param {import('angular').ITemplateCacheService} $templateCache
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {Knitiv.Angular.Compile} $compile
	 * @param {Knitiv.Angular.Sce} $sce
	 * @param {Knitiv.Scope} $scope
	 * @param {UserModel} User
	 */
	constructor(
		$templateCache,
		$translate,
		$compile,
		$sce,
		$scope,
		User,
	) {
		this.$templateCache = $templateCache;
		this.$translate = $translate;
		this.$compile = $compile;
		this.$scope = $scope;
		this.$sce = $sce;
		this.User = User;
		this.html = '';
		this.popoverIsOpen = false;
		this.isTemplate = false;

		/** @type {KnitivEditor | undefined} */
		this.editor = undefined;
	}

	async openPopOver() {
		const condition = {
			repre: {
				lang_kid: 'K_NODE;CODE',
				value:    'home-search-help',
			},
		};
		if (this.popoverIsOpen) {
			this.popoverIsOpen = false;
		}
		else {
			try {
				const result = await APIV5.instance.objectList(
					{ classKid: 'K_NODE;KSYSINFOPOINT', condition },
					{ id: 'pop-info.open-pop-over' },
				);

				this.$scope.$apply(async () => {
					if (Object.keys(result.list).length > 0) {
						const repre = result.list[Object.keys(result.list)[0]].repre_all;
						const lang = this.User.getContext().lang[0];
						const name = repre[lang]?.name || repre['K_NODE;UNIVERSEL']?.name;
						if (!name) {
							console.error('no repre');
						}

						this.name = name;

						const code = `
	<text-editor
		readonly="true"
		hide-toolbar="true"
		class="kdocument"
		ng-model="$ctrl.name"
	></text-editor>`;

						this.html = '__popover__.html';
						this.$templateCache.put(this.html, code);
						this.isTemplate = true;
					}
					else {
						this.html = this.$translate.instant('error.no-related-info');
					}
					this.popoverIsOpen = true;
				});
			}
			catch (error) {
				console.error(error);
				this.popoverIsOpen = false;
			}
		}
	}
}
